import React from 'react'
import pdf from '../../../../static/alcance.pdf'

function AlcanceDeSIG () {
  return (
    <iframe
      title='alcance'
      src={pdf}
      style={{ width: '100%', minHeight: '85vh', marginTop: '-2%' }}
    />
  )
}

export default AlcanceDeSIG
